import * as React from 'react';
import { History } from 'history';
import { Grid } from '@mui/material';
import { Card, Swipe, Tabs } from '.';
import AppService, { direction } from '../services/app.service';

interface Props {
  history?: History;
  id?: string;
  direction?: direction;
  spacing?: number;
  content: {
    caption: string,
    color?: any;
    hide?: boolean,
    leftPosition?: boolean,
    disableCard?: boolean,
    disableSwipe?: boolean,
    child?: React.ReactNode,
  }[];
  reverseChild?: boolean;
  fixWidth?: number;
}

export const Layout: React.FunctionComponent<Props> = (props) => {
  const historyState: any = props.history?.location.state;
  const isMobile = AppService.isMobile();
  const isColumn = props.direction ==='column';
  const [tabIdx, setTabIdx] = React.useState(isMobile? ((!props.fixWidth && historyState.tab) || 0) : -1);
  const [fixWidth, setFixWidth] = React.useState(props.fixWidth || 0);
  const getFixWidthLeft = () =>  + (fixWidth / (window.innerWidth/12)).toFixed(2);
  const [fixWidthLeft, setFixWidthLeft] = React.useState(getFixWidthLeft());

  const content = () => {
    var result = props.content.filter((d: any) => !d.hide);
    if (isMobile && props.direction?.includes('reverse')) result = result.slice().reverse();
    return result;
  }

  const getTabIndex = (value: number) => {
    setTabIdx(value);
    AppService.historyState('tab', value, true);
  }
  
  const onChangeSwipe = async(value: string) => {
    var tabIdxNew = tabIdx;
    
    if (content()?.[tabIdxNew]?.disableSwipe) return;
    if (value.startsWith('end')) {
      if (value.endsWith('left') && tabIdx < content().length-1) tabIdxNew = tabIdx + 1;
      else if (value.endsWith('right') && tabIdx > 0) tabIdxNew = tabIdx - 1;
      if (isMobile && tabIdxNew !== tabIdx) getTabIndex(tabIdxNew);
    }
  }

  const onResize = React.useCallback(() => {setFixWidthLeft(getFixWidthLeft())}, []);  

  React.useEffect(() => {
    setFixWidth(props.fixWidth || 0);
    setFixWidthLeft(getFixWidthLeft());
    window.addEventListener('resize', onResize);
    
    return () => {
      window.addEventListener('resize', onResize);
    }

  }, [props.fixWidth, getFixWidthLeft(), tabIdx])
  
  return (
    <Swipe onChange={onChangeSwipe}>
      {!fixWidth && tabIdx>=0 && <Tabs id={props.id} value={tabIdx} tab={content()} getTabIndex={getTabIndex}/>}
      <Grid container direction={props.direction} spacing={isMobile? 0 : (props.spacing || 1)} pt={isMobile? 1 : 0} pb={fixWidth? 0 : 1}>
        <Grid item container alignContent='flex-start' xs={12} md={fixWidth? fixWidthLeft : 4} >
          {content()?.map((d, i) => {
            if (i===0 && [-1,i].includes(tabIdx) && !d.hide)
            return (
              <Grid key={i} item container minHeight={isMobile? '65vh' : ''}>
                {d.child? (d.disableCard? d.child : <Card color={d.color}> {d.child} </Card>) : ''}
              </Grid>
            )
          })}
        </Grid>
        
        <Grid item container direction={props.reverseChild? 'column-reverse' : 'column'} justifyContent='start' xs={isColumn? 0: 12} md={isColumn? 0: (fixWidth? 12 - fixWidthLeft : 8)} spacing={1} >
          {content()?.map((d, i) => {
            if (i>0 && [-1,i].includes(tabIdx) && !d.hide)
            return (
              <Grid key={i} item container alignContent='flex-start' minHeight={isMobile? '65vh' : ''}>
                {d.child? (d.disableCard? d.child : <Card color={d.color}> {d.child} </Card>) : ''}
              </Grid>
            )
          })}
        </Grid>
      </Grid>
    </Swipe>
  );
}
